import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
    selector: 'app-fc-twofour-twofive',
    templateUrl: './fc-twofour-twofive.component.html',
    styleUrls: ['./fc-twofour-twofive.component.scss']
})
export class FcTwofourTwofiveComponent implements OnInit {
    src: string;
    isLoading = true;

    pdfSrc: string[] = [
        '/assets/pdf/MOUs 2024-25.pdf'
    ];

    ngOnInit(): void {
        this.changeRoute('1');
    }

    changeRoute(year: string) {
        this.isLoading = true;

        $('.first,.second,.third,.four,.five,.six,.seven,.eight,.nine').removeClass('active');

        if (year == '1') { $('.first').addClass('active'); this.src = this.pdfSrc[0]; }
    }

    hideLoader() {
        this.isLoading = false;
    }
}
